export default function navigationBackgroundReducer(
  state = {
    prelogin: '',
    postlogin: '',
    post_login_mini_chains: '',
    fetching: false,
    fetched: false,
  },
  action
) {
  switch (action.type) {
    case 'GET_NAVIGATION_BACKGROUND_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false,
      };
    }
    case 'GET_NAVIGATION_BACKGROUND_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        prelogin: action.payLoad.pre_login,
        postlogin: action.payLoad.post_login,
        post_login_mini_chains: action.payLoad.post_login_mini_chains,
        meta: action.payLoad.meta,
      };
    }
    case 'GET_NAVIGATION_BACKGROUND_REJECTED': {
      return {
        ...state,
        errors: action.payLoad.errors,
      };
    }
    case 'CLEAR_NAVIGATION_BACKGROUND': {
      return {
        ...state,
        prelogin: '',
        postlogin: '',
        post_login_mini_chains: '',
        meta: undefined,
      };
    }
    default:
  }

  return { ...state };
}
